import {JunctionDetails} from "../components/modules/asset/maps/ticketing/AssetDetails";
import {itmType} from "../components/modules/asset/purchase/material/statesProvider/materialContext";
import {
  AtsMrfMstForRfqsEdge,
  rfqPendingItemType,
} from "../components/modules/asset/purchase/quotation/queries/types";
import {YesNo} from "./Enum.types";

export interface IObjectKeys {
  [key: string]:
    | string
    | number
    | boolean
    | string[]
    | number[]
    | responseType
    | responseType[]
    | rfqPendingItemType
    | AtsMrfMstForRfqsEdge
    | null
    | undefined
    | JunctionDetails;
}

export interface CustomerFormType extends IObjectKeys {
  name: string;
  address: string;
  place: string;
  state: string;
  pin: string;
  country: string;
  contactPerson: string;
  contactPersonDesign: string;
  email: string;
  mobile: string;
  url: string;
  panNo: string;
  gstNo: string;
  gstStateCode: string;
}

export interface UserFormType extends IObjectKeys {
  name: string;
  address: string;
  place: string;
  state: string;
  pin: string;
  mobile: string;
  email: string;
  empType: string;
  companyID: number;
  subsidiaryID: number;
  siteID: number;
  kgid: number;
  metalNo: number;
}

export interface CompanyFormData extends IObjectKeys {
  // Company Details
  name: string; // Company Name
  address: string; // Address
  pin: string; // Pin Code
  telephone: string; // Telephone
  email: string; // Email
  mobile: string; // Mobile No.
  place: string;
  country: string;
  state: string;
  // Contact Details
  contactPerson: string; // Name
  contactPersonDesign: string; // Designation
  contactPersonEmail: string; // Email
  contactPersonMobile: string; // Mobile No.
  url: string; // Company Url

  // Statuary Details
  enableGst: boolean; // Enable GST
  gstNo: string; // GSTIN No.
  tanNo: string; // TAN Registration No.
  panNo: string; // PAN Registration No.
  enableTds: boolean; // Enable TDS
  enableTcs: boolean; // Enable TCS
  vatNo: string; // Enable TCS

  regType: string;
  gstState: string;
  latitude: string;
  longitude: string;
  gstStateCode: string;
  icon: string;
}

export interface subsidiarySiteInputs extends IObjectKeys {
  name: string;
  address: string;
  place: string;
  state: string;
  pin: string;
  country: string;
  contactPerson: string;
  contactPersonDesign: string;
  contactPersonEmail: string;
  contactPersonMobile: string;
  email: string;
  mobile: string;
  latitude: string;
  longitude: string;
  gstNo: string;
  icon: string;
}

export interface stockItemInputs extends IObjectKeys {
  desc: string;
  code: string;
  uom: string;
  enableGst: boolean;
  hsnCode: string;
  igst: string;
  sgst: string;
  cgst: string;
  isStockOrService: string;
  trackSerial: boolean;
  trackBatch: boolean;
  trackBrand: boolean;
  trackModel: boolean;
  trackExpiry: boolean;
  trackWarranty: boolean;
  trackInstallation: boolean;
  trackMaintenance: boolean;
  trackCalibration: boolean;
  isPerishable: boolean;
  isConsumable: boolean;
  imageNeeded: boolean;
  trackAmc: boolean;
  trackGeoLocation: boolean;
  trackInsurance: boolean;
  isModule: boolean;
  isComponent: boolean;
  image_path: string;
  additionalPropertyNeeded: boolean;
  noOfAdditionalProperties: number;
  AdditionalPropertyDesc1: string;
  AdditionalPropertyDesc2: string;
  AdditionalPropertyDesc3: string;
  AdditionalPropertyDesc4: string;
  AdditionalPropertyDesc5: string;
  AdditionalPropertyDesc6: string;
  AdditionalPropertyDesc7: string;
  AdditionalPropertyDesc8: string;
  AdditionalPropertyDesc9: string;
  AdditionalPropertyDesc10: string;
  AdditionalPropertyDatatype1: string;
  AdditionalPropertyDatatype2: string;
  AdditionalPropertyDatatype3: string;
  AdditionalPropertyDatatype4: string;
  AdditionalPropertyDatatype5: string;
  AdditionalPropertyDatatype6: string;
  AdditionalPropertyDatatype7: string;
  AdditionalPropertyDatatype8: string;
  AdditionalPropertyDatatype9: string;
  AdditionalPropertyDatatype10: string;
  stckDetailsEntryIsMultiple: boolean;
  stckCategoryID: number;
  stckGroupID: number;
  stckManufacturerID: number;
  stckUomID: number;
  icon: string;
}

export interface SupplierFormDetails extends IObjectKeys {
  supplier_name: string;
  address: string;
  city: string;
  state: string;
  pin: string;
  country: string;
  phone: string;
  email: string;

  multi_location: boolean;
  includeDeviceType?: boolean;
  contactPerson: string;
  contactPersonAddress: string;
  contactPersonState: string;
  contactPersonCity: string;
  contactPersonPin: string;
  contactPersonCountry: string;
  contactPersonMobile: string;
  contactPersonEmail: string;
  contactPersonAadhar: string;
}

export interface optionsType {
  label: string;
  value: string;
}

export enum ReturnType {
  RESPONSE_TYPE = "RESPONSE_TYPE",
  QUERY_TYPE = "QUERY_TYPE",
  BOTH = "BOTH",
  VALUE_SAME_AS_LABEL = "VALUE_SAME_AS_LABEL",
  WITH_ID = "WITH_ID",
  NO_STANDARD_CASE = "NO_STANDARD_CASE",
}

export enum PredefinedDataTypes {
  STATE = "STATE",
  CITY = "CITY",
  PLACE = "PLACE",
  BLOODGROUP = "BLOOD_GROUP",
  DISTRICT = "DISTRICT",
  RELIGION = "RELIGION",
  CASTE = "CASTE",
  SUBCASTE = "SUBCASTE",
  CASTE_GROUP = "CASTE_GROUP",
  SC_ST = "SC_ST",
  YESNO = "YESNO",
  RURAL_URBAN = "RURAL_URBAN",
  MOTHER_TONGUE = "MOTHER_TONGUE",
  NATIONALITY = "NATIONALITY",
  FREEPAYMENTSEAT = "FREE_PAYMENT",
  STATEORINTERSTATE = "PUR_STATE",
  SEATGOTTHROUGH = "SEAT_GOT_THROUGH",
  CATEGORY = "CATEGORY",
  MARTIAL_STATUS = "MARTIAL_STATUS",
  STUDENT_STATUS = "STUDENT_STATUS",
  STUDENT_FEE_TYPE = "STUDENT_FEE_TYPE",
  PARENT_TYPE = "PARENT_TYPE",
  STAFF_TYPE = "STAFF_TYPE",
  GENDER = "GENDER",
  CR_DB = "CR_DB",
  BANK_COLLECTION = "BANK_COLLECTION",
  BOOK_STATUS = "BOOK_STATUS",
  OCCUPATION = "OCCUPATION",
  LIB_DONOR_TYPE = "LIB_DONOR_TYPE",
  EARNING_DEDUCTION = "EARNING_DEDUCTION",
  SAL_TYPE = "SAL_TYPE",
  DEDUCTION_LEDGER = "DEDUCTION_LEDGER",
  TEST_TYPE = "TEST_TYPE",
  HOLIDAY_TYPE = "HOLIDAY_TYPE",
  HOLIDAY_FULL_HALF_DAY = "HOLIDAY_FULL_HALF_DAY",
  CERTIFICATE = "CERTIFICATE",
  LEAVE_TYPE = "LEAVE_TYPE",
  ENQ_FOLLOW_UP_STATUS = "ENQ_FOLLOW_UP_STATUS",
  ENQ_REFERENACE_FROM = "ENQ_REFERENACE_FROM",
  COUNTRY = "COUNTRY",
  GST_UOM = "GST_UOM",
  GST_REGISTRATION_TYPE = "GST_REGISTRATION_TYPE",
}

export interface YesNoOptionsType {
  label: YesNo;
  value: boolean;
}

export interface responseType {
  value: number;
  label: string;
  isChecked?: boolean;
  defaultLogo?: string;
}

export interface YesNoOptionsType {
  label: YesNo;
  value: boolean;
}

export interface SupplierRequiredDetails extends IObjectKeys {
  gstNo: string;
  tanNo: string;
  panNo: string;
  vatNo: string;
  bankAcNo: string;
  bankName: string;
  bankBranch: string;
  bankIfsc: string;
  bankMicr: string;
  proficiency: string;
  alterContactPerson: string;
  alterContactPersonMobile: string;
  alterContactPersonEmail: string;
  alterContactPersonAadhar: string;
}

export interface ProjectRequiredDetails extends IObjectKeys {
  name: string;
  workOrderNum: string;
  contractValue: number;
  projectScope: string;
  contractSignedWith: string;
  loa: string;
  agreementDate: string;
  startDate: string;
  endDate: string;
  insuranceStartDate: string;
  insuranceEndDate: string;
  goLiveDate: string;
  amcStartDate: string;
  amcScope: string;
  amcInsuranceStartDate: string;
  amcInsuranceEndDate: string;
  dlpStartDate: string;
  dlpEndDate: string;
  bgValue: number;
  bgStartDate: string;
  bgEndDate: string;
  slaBillingCycle: string;
  agreementFile: string;
  endAgreementFile: string;
  isMeetingActive: boolean
}

export interface ProjectExtRequiredDetails extends IObjectKeys {
  name: string;
  projectScope: string;
  contractSignedWith: string;
  loa: string;
  agreementDate: string;
  startDate: string;
  endDate: string;
  agreementFile: string;
  endAgreementFile: string;
}

export interface MultiLocationForm extends IObjectKeys {
  address: string; // Address
  city: string; // City
  pin: string; // Pin Code
  state: string; // State
  country: string; // Country
  email: string; // Email
  phone: string; // Phone (Mobile)
  gstNo: string; // GST No
  tanNo: string; // TAN No
  vatNo: string; // VAT No
  panNo: string; // PAN No (corrected key)
  contactPerson: string; // Contact Name
  contactPersonAddress: string; // Contact Person Address
  contactPersonCity: string; // Contact Person City
  contactPersonPin: string; // Contact Person Pin
  contactPersonState: string; // Contact Person State
  contactPersonCountry: string; // Contact Person Country
  contactPersonEmail: string; // Contact Person Email
  contactPersonMobile: string; // Contact Person Mobile
  contactPersonAadhar: string; // Contact Person Aadhar
}

// export interface

export interface ItemList extends IObjectKeys {
  itemId: number;
  udfItemDesc: string;
  uom: string;
  presentStk: string;
  reqQty: string;
  approxRate: string;
  deliveryRate: string;
  installationRate: string;
  otherRate: string;
  tax: string;
  trnNeedBefore: string;
  priority: string;
  usedFor: string;
  remarks: string;
  taxable: string;
  approxValue: string;
  taxedValue: string;
  approxTaxableValue: string;
}

export interface ItemListArray {
  itemId: number;
  uom: string;
  udfItemDesc: string;
  presentStk: number;
  reqQty: number;
  approxRate: number;
  taxable: number;
  tax: number;
  approxValue: number;
  priority: string;
  trnNeedBefore: string;
  preferedSupplierIds: string;
  usedFor: string;
  remarks: string;
  suppliersList: responseType[];
  selectedItem: itmType;
  deliveryRate: number;
  installationRate: number;
  otherRate: number;
  taxedValue: number;
  approxTaxableValue: number;
}

export interface viewMaterialForm extends IObjectKeys {
  mrfNo: string;
  materialReqFor: string;
  sub_name: string;
  refNo: string;
  reqDate: string;
  raisedBy: string;
  remarks: string;
  scan_copy: string;

  narration: string;
  // acceptDate: string;
  // acceptedBy: string;
}

export interface concludeItemDataType extends IObjectKeys {
  uom_desc: string;
  uom: string;
  udfItemDesc: string;
  present_stock: string;
  required_qty: string;
  approx_rate: string;
  taxable_value: string;
  tax: string;
  net_value: string;
  priority: string;
  need_before: string;
  prefered_vendor: string;
  used_for: string;
  remark: string;
}

export interface reqQtyFormDataType {
  reqQty: string;
}
export interface concludeFormDataType extends IObjectKeys {
  acceptQty: string | number;
  acceptRate: string | number;
  acceptValue: string | number;
  acceptRemarks: string;
  udfItemDesc: string;
  acceptStatus: string;
}

export interface rfqForm extends IObjectKeys {
  lastDateForSubmission: string;
  rfqPreparedBy: string;
  rfqAuthorisedBy: string;
  tc: string;
  payTerms: string;
  remarks: string;
}

export interface quotationDetailsForm extends IObjectKeys {
  lastDateForSubmission: string;
  gstNo: string;
  companyName: string;
  rfqNo: string;
  panNo: string;
  city: string;
  narration: string;
}
export interface quotationForm extends quotationDetailsForm {
  narration: string;
  generalTerms: string;
  generalPaymentTerms: string;
}

export interface RfqTrnSupply extends IObjectKeys {
  isAccepted: string;
  itemDescChanged: string;
  quotedDesc: string;
  quotedQty: string;
  quotedRate: string;
  quotedTax: string;
  totalAmt: string;
  quotedDelvChrg: string;
  quotedInstChrg: string;
  quotedOtherChrg: string;
  net: string;
  quotedRemarks: string;
  anyOtherCharges: string;
  quotedAnyChanges: string;
}

export interface RfqTrnSupplyItemDetails extends IObjectKeys {
  itemDesc: string;
  item_desc: string;
  required_qty: string;
  terms: string;
  payment_terms: string;
}

export interface rfqPoFormData extends IObjectKeys {
  slNo: string;
  rfqTrnSlNo: number;
  udfItemDesc: string;
  itemUom: string;
  itemQty: string;
  itemRate: string;
  itemOther: string;
  itemTaxable: string;
  itemTax: string;
  itemDelvChrg: string;
  itemInstChrg: string;
  itemValue: string;
  remarks: string;
  itemDeliverySts: string;
  itemDeliveryDate: string;
  itemID: number;
  rfqTrnID: number;
  rfqID: number;
  rfqDate: string;
  rfqNo: string;
  netTotal: number;
}
export interface rfqPoTableData {
  slNo: number;
  rfqTrnSlNo: number;
  udfItemDesc: string;
  itemUom: string;
  itemQty: number;
  itemRate: number;
  itemOther: number;
  itemTaxable: number;
  itemTax: number;
  itemDelvChrg: number;
  itemInstChrg: number;
  itemValue: number;
  remarks: string;
  itemDeliverySts: number;
  itemDeliveryDate: string;
  itemID: number;
  rfqTrnID: number;
  rfqID: number;
  rfqDate: string;
  rfqNo: string;
}

export interface mrfToPoFormData extends IObjectKeys {
  mrfNo: string;
  mrfDate: string;
  slNo: string;
  udfItemDesc: string;
  itemUom: string;
  itemQty: string;
  itemRate: string;
  itemOther: string;
  itemTaxable: string;
  itemTax: string;
  itemInstChrg: string;
  itemDelvChrg: string;
  itemDeliveryDate: string;
  itemValue: string;
  netTotal: number;
  itemID: number;
  mrfTrnID: number;
  mrfID: number;

  remarks: string;
  itemDeliverySts: string;
}

export interface mrfToPoTableData {
  mrfNo: string;
  mrfDate: string;
  slNo: string;
  udfItemDesc: string;
  itemUom: string;
  itemQty: string;
  itemRate: string;
  itemOther: string;
  itemTaxable: string;
  itemTax: string;
  itemInstChrg: string;
  itemDelvChrg: string;
  itemDeliveryDate: string;
  itemValue: string;
  netTotal: number;
  itemID: number;
  mrfTrnID: number;
  mrfID: number;
  remarks: string;
  itemDeliverySts: string;
}

export interface obFormType extends IObjectKeys {
  obQty: string;
  rate: string;
}

export interface ObDetailsType extends IObjectKeys {
  code: string;
  description: string;
  uom: string;
  category: string;
  sub_category: string;
  manufacturer: string;
  model: string;
  hsn_code: string;
  igst_rate: number;
  cgst_rate: number;
  sgst_rate: number;
}

export interface StockEntryItem extends IObjectKeys {
  description: string;
  uom: string;
  category: string;
  sub_category: string;
  manufacturer: string;
}

export interface ViewItemFormType extends IObjectKeys {
  description: string;
  code: string;
  gst_applicable: string;
  category: string;
  sub_category: string;
  uom: string;
  model: string;
  slNo: string;
  subsidiary: string;
}

export interface ViewItemForm extends IObjectKeys {
  description: string;
  code: string;
  gst_applicable: string;
  category: string;
  sub_category: string;
  uom: string;
  model: string;
}

export interface SupplierFormState extends IObjectKeys {
  supplier_ref_no: string;
  supplied_date: string;
  supplied_qty: string;
  supplied_rate: string;
}

export interface TableStockEntryItem extends IObjectKeys {
  slNo: string;
  serialNo: string;
  batch: string;
  expiry: string;
  warrantyStartDate: string;
  warrantyEndDate: string;
  maintainedBy: string;
  amcEnabled: boolean;
  amcStartDate: string;
  amcEndDate: string;
  geoLocation: string;
  insuranceStartDate: string;
  insuranceEndDate: string;
  stockLocation: string;
}

export interface TicketFormType extends IObjectKeys {
  reason: string;
  type: string;
  status: string;
  remarks: string;
  poleNum: number;
  selectedAsset: boolean;
}

export interface TicketDetailsType extends IObjectKeys {
  ticketNo: string;
  ticketRemarks: string;
  ticketReason: string;
  assetStatus: string;
  assignee: string;
  priority: string;
  reportedDateAndTime: string;
  openRemarks: string;
  ticketStatus: string;
}

export interface fromToDatesType {
  startDate: string;
  endDate: string;
}

export interface inputDatesType extends fromToDatesType, IObjectKeys {}

export interface idAndFlagType {
  id: number;
  flag: boolean;
}

export interface tableHeaderForm extends IObjectKeys {
  header: string;
  initData: boolean;
  dataType: string;
  status: boolean;
}
